import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { FiClock, FiMonitor, FiCalendar, FiUsers } from "react-icons/fi";
import {
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
  FaChevronDown,
  FaChevronRight,
  FaTimes,
} from "react-icons/fa";
import TraineeHeader from "../Trainee/TraineeHeader";
import SaveButton, { SAVED_TYPES } from "../Trainee/SaveButton";
import CourseHeader from "../Home/CourseHeader";
import Footers from "../Home/Footers";
import FemaleLogo from "./FemaleLogo.jpg";
import MaleLogo from "./MaleLogo.jpg";
import Profile from "../Home/Profile.png";
import "./CourseContent.css";
import AxiosInstance from "../Home/AxiosInstance";
import { storeTokens, buildTraineeSignInPayload } from "../Home/auth";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Home/publicPages.css";

export default function CourseContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const { batchId } = useParams();
  const courseMaterialId = localStorage.getItem("course_material_id");

  const [courseData, setCourseData] = useState(null);
  const [topics, setTopics] = useState([]);
  const [expandedTopic, setExpandedTopic] = useState(null);
  const [expandedSubtopic, setExpandedSubtopic] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isSignupMode, setIsSignupMode] = useState(false);
  const [isEnrolled, setIsEnrolled] = useState(false);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    mobile_no: "",
  });
  const isFromTraineeProfile =
    location.state?.from === "trainee-profile" ||
    Boolean(localStorage.getItem("traineeId"));

  const handleChange = (e) => {
    const key = e.target.name || e.target.id;
    setFormData({ ...formData, [key]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    const { first_name, last_name, email, password, mobile_no } = formData;

    if (!first_name || !last_name || !email || !password || !mobile_no) {
      alert("Please fill all fields");
      return;
    }

    try {
      const signupRes = await AxiosInstance.post("companies/signup", formData);
      const signupData = signupRes.data;
      const traineeId = signupData.trainee_id;
      storeTokens(signupData);
      localStorage.setItem("traineeId", traineeId);
      await enrollUser(traineeId);
    } catch (err) {
      console.error(err);
      if (err.response) {
        const data = err.response.data;
        let errorMessage = "Something went wrong";
        if (data.error) {
          const errorObj = data.error;
          const firstKey = Object.keys(errorObj)[0];
          errorMessage = Array.isArray(errorObj[firstKey])
            ? errorObj[firstKey][0]
            : errorObj[firstKey];
        }
        alert(errorMessage);
      } else {
        alert("Something went wrong during signup.");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      alert("Please enter email or mobile number and password");
      return;
    }

    try {
      const signinRes = await AxiosInstance.post(
        "companies/signin",
        buildTraineeSignInPayload(formData.email, formData.password)
      );
      const signinData = signinRes.data;
      const traineeId = signinData.trainee.trainee_id;
      storeTokens(signinData);
      localStorage.setItem("traineeId", traineeId);
      await enrollUser(traineeId);
    } catch (err) {
      console.error(err);
      if (err.response) {
        alert(err.response.data?.error || "Invalid credentials.");
      } else {
        alert("Something went wrong during signin.");
      }
    }
  };

  const enrollUser = async (traineeId) => {
    const enrollmentPayload = {
      is_enrolled: "Enrolled",
      enrolled_at: new Date().toISOString(),
      batch: parseInt(batchId),
      trainee: parseInt(traineeId),
    };

    try {
      await AxiosInstance.post("companies/enrollment/", enrollmentPayload);
      setIsEnrolled(true);
      setShowModal(false);
      alert("Enrollment successful!");
      navigate("/trainee-profile");
    } catch (err) {
      console.error(err);
      if (err.response?.status === 409) {
        setIsEnrolled(true);
        setShowModal(false);
        alert("Trainee is already enrolled in this batch.");
        return;
      }
      alert(err.response?.data?.error || "Enrollment failed.");
    }
  };

  const handleEnrollClick = async () => {
    if (isFromTraineeProfile) {
      const confirmed = window.confirm(
        "Do you want to enroll into the course?"
      );
      if (confirmed) {
        const traineeId = localStorage.getItem("traineeId");
        if (traineeId) {
          await enrollUser(traineeId);
        } else {
          alert("Trainee ID not found. Please sign in again.");
        }
      }
    } else {
      setShowModal(true);
    }
  };

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const res = await AxiosInstance.get(`companies/batches/${batchId}/`);
        if (res.data?.length > 0) setCourseData(res.data[0]);
      } catch (err) {
        console.error(err);
      }
    };

    const fetchTopics = async () => {
      try {
        const res = await AxiosInstance.get(
          `companies/topics/${courseMaterialId}/`
        );
        const topicsData = res.data || [];
        const topicsWithSub = await Promise.all(
          topicsData.map(async (topic) => {
            try {
              const subRes = await AxiosInstance.get(
                `companies/sub-topics/${topic.topic_id}/`
              );
              return { ...topic, subtopics: subRes.data };
            } catch {
              return { ...topic, subtopics: [] };
            }
          })
        );
        setTopics(topicsWithSub);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCourse();
    fetchTopics();
  }, [batchId, courseMaterialId]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await AxiosInstance.get(`companies/reviews/${batchId}/`);
        setReviews(res.data || []);
      } catch (err) {
        console.error(err);
      }
    };
    fetchReviews();
  }, [batchId]);

  useEffect(() => {
    const checkEnrollmentStatus = async () => {
      const traineeId = localStorage.getItem("traineeId");
      if (!traineeId) return;

      try {
        const res = await AxiosInstance.get(
          `companies/enrollments/${batchId}/`
        );
        const enrollments = res.data || [];
        const isUserEnrolled = enrollments.some(
          (enrollment) =>
            enrollment.trainee.trainee_id === parseInt(traineeId) &&
            enrollment.is_enrolled === "Enrolled"
        );
        setIsEnrolled(isUserEnrolled);
      } catch (err) {
        console.error("Error checking enrollment status:", err);
      }
    };

    checkEnrollmentStatus();
  }, [batchId]);

  if (!courseData) {
    return (
      <div className="CoursePage1">
        {isFromTraineeProfile ? <TraineeHeader /> : <CourseHeader />}
        <p className="cd-loading">Loading course details…</p>
        <Footers />
      </div>
    );
  }

  const { course_material } = courseData;
  const { user, trainer, description } = course_material;
  const instructor = user || trainer;
  const courseName = course_material?.course?.course_name || "Course";
  const courseLogo = course_material?.course?.course_logo;
  const logoSrc = courseLogo
    ? courseLogo.startsWith("http")
      ? courseLogo
      : `${AxiosInstance.defaults.baseURL}media/${String(courseLogo).replace(
          /\\/g,
          "/"
        )}`
    : null;

  const avgRating =
    reviews.length > 0
      ? reviews.reduce((sum, r) => sum + Number(r.rating || 0), 0) /
        reviews.length
      : null;

  const lectureCount = topics.reduce(
    (sum, t) => sum + (t.subtopics?.length || 0),
    0
  );

  const getDisplayName = (person) =>
    person?.alias_name?.trim() ||
    `${person?.first_name || ""} ${person?.last_name || ""}`.trim() ||
    "Instructor";

  const getImageSrc = (person) => {
    if (!person) return Profile;
    const baseURL = process.env.REACT_APP_API_ALS_URL;
    if (person.image_path) {
      return `${baseURL}media/${person.image_path.replace(/\\/g, "/")}`;
    }
    return person.gender === "Male" ? MaleLogo : FemaleLogo;
  };

  function formatContent(text) {
    if (!text) return "";
    const lines = text
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line !== "");
    const output = [];
    let listBuffer = [];

    const flushList = () => {
      if (listBuffer.length > 0) {
        output.push(
          `<ul>${listBuffer.map((item) => `<li>${item}</li>`).join("")}</ul>`
        );
        listBuffer = [];
      }
    };

    lines.forEach((line) => {
      if (/^[-*]\s+/.test(line)) {
        listBuffer.push(line.replace(/^[-*]\s+/, "").trim());
      } else {
        flushList();
        output.push(`<p>${line}</p>`);
      }
    });
    flushList();
    return output.join("");
  }

  const renderStars = (rating, size = 14) =>
    [...Array(5)].map((_, j) => {
      if (j < Math.floor(rating))
        return <FaStar key={j} color="#f59e0b" size={size} />;
      if (j === Math.floor(rating) && rating % 1 !== 0)
        return <FaStarHalfAlt key={j} color="#f59e0b" size={size} />;
      return <FaRegStar key={j} color="#d1d5db" size={size} />;
    });

  const enrollButton = !isEnrolled ? (
    <button type="button" className="cd-enroll-btn" onClick={handleEnrollClick}>
      Enroll now
    </button>
  ) : (
    <button type="button" className="cd-enroll-btn enrolled" disabled>
      Enrolled
    </button>
  );

  return (
    <div
      className={`CoursePage1${
        isFromTraineeProfile ? " CoursePage1--trainee" : ""
      }`}
    >
      {isFromTraineeProfile ? <TraineeHeader /> : <CourseHeader />}

      <section className="cd-hero">
        <div className="cd-hero-inner">
          <div className="cd-hero-copy">
            <nav className="als-breadcrumb" aria-label="Breadcrumb">
              <Link
                to="/courses"
                state={
                  isFromTraineeProfile ? { from: "trainee-profile" } : undefined
                }
              >
                Courses
              </Link>
              <span className="als-breadcrumb-sep" aria-hidden="true">
                ›
              </span>
              <span aria-current="page">{courseName}</span>
            </nav>
            <div className="cd-badges">
              {courseData.mode && (
                <span className="cd-badge mode">{courseData.mode}</span>
              )}
              {avgRating >= 4.5 && (
                <span className="cd-badge rated">Top rated</span>
              )}
            </div>
            <h1>{courseName}</h1>
            <div className="cd-meta">
              {instructor && (
                <div className="cd-meta-item cd-meta-instructor">
                  <img
                    src={getImageSrc(instructor)}
                    alt=""
                    className="cd-meta-avatar"
                  />
                  <span>{getDisplayName(instructor)}</span>
                </div>
              )}
              {avgRating != null && (
                <div className="cd-meta-item">
                  <strong>{avgRating.toFixed(1)}</strong>
                  <span className="cd-stars">{renderStars(avgRating)}</span>
                  <span>({reviews.length} ratings)</span>
                </div>
              )}
              {courseData.batch_starts_at && (
                <div className="cd-meta-item">
                  <FiCalendar /> Starts {courseData.batch_starts_at}
                </div>
              )}
            </div>
          </div>
          <div className="cd-hero-media">
            {logoSrc ? (
              <img src={logoSrc} alt="" />
            ) : (
              <div className="cd-hero-placeholder">{courseName.charAt(0)}</div>
            )}
          </div>
        </div>
      </section>

      <div className="cd-body">
        <div className="cd-layout">
          <main className="cd-main">
            <section className="cd-card">
              <h2>About this course</h2>
              <div
                className="cd-prose"
                dangerouslySetInnerHTML={{
                  __html:
                    formatContent(description) ||
                    "<p>No course description available.</p>",
                }}
              />
            </section>

            <section className="cd-card">
              <div className="cd-curriculum-head">
                <h2>Curriculum</h2>
                <p>
                  {topics.length} topic{topics.length === 1 ? "" : "s"}
                  {lectureCount > 0
                    ? ` · ${lectureCount} lecture${
                        lectureCount === 1 ? "" : "s"
                      }`
                    : ""}
                  {courseData.duration ? ` · ${courseData.duration}` : ""}
                </p>
              </div>

              {topics.length === 0 ? (
                <p className="cd-empty">No topics available yet.</p>
              ) : (
                <div className="cd-topics">
                  {topics.map((topic, index) => {
                    const showContent = isEnrolled || index < 2;
                    const open = expandedTopic === topic.topic_id;

                    return (
                      <div key={topic.topic_id} className="cd-topic">
                        <button
                          type="button"
                          className="cd-topic-header"
                          onClick={() =>
                            setExpandedTopic(open ? null : topic.topic_id)
                          }
                        >
                          <span>{topic.topic_name}</span>
                          <span className="cd-topic-meta">
                            {topic.subtopics?.length
                              ? `${topic.subtopics.length} lectures`
                              : ""}
                            {open ? <FaChevronDown /> : <FaChevronRight />}
                          </span>
                        </button>

                        {open && (
                          <div className="cd-topic-body">
                            <div className="cd-prose muted">
                              {showContent ? (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: formatContent(
                                      topic.content ||
                                        "No topic description available."
                                    ),
                                  }}
                                />
                              ) : (
                                <em>Enroll to view topic content</em>
                              )}
                            </div>

                            {topic.subtopics?.length > 0 ? (
                              <ul className="cd-subtopics">
                                {topic.subtopics.map((sub) => {
                                  const subOpen =
                                    expandedSubtopic === sub.sub_topic_id;
                                  return (
                                    <li key={sub.sub_topic_id}>
                                      <button
                                        type="button"
                                        className="cd-subtopic-header"
                                        onClick={() =>
                                          setExpandedSubtopic(
                                            subOpen ? null : sub.sub_topic_id
                                          )
                                        }
                                      >
                                        <span>{sub.sub_topic_name}</span>
                                        {subOpen ? (
                                          <FaChevronDown size={12} />
                                        ) : (
                                          <FaChevronRight size={12} />
                                        )}
                                      </button>
                                      {subOpen && (
                                        <div className="cd-subtopic-body">
                                          {showContent ? (
                                            <div
                                              className="cd-prose muted"
                                              dangerouslySetInnerHTML={{
                                                __html: formatContent(
                                                  sub.sub_topic_content ||
                                                    "No subtopic content available."
                                                ),
                                              }}
                                            />
                                          ) : (
                                            <em>
                                              Enroll to view subtopic content
                                            </em>
                                          )}
                                        </div>
                                      )}
                                    </li>
                                  );
                                })}
                              </ul>
                            ) : (
                              <p className="cd-empty">
                                <em>No subtopics available.</em>
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </section>

            <section className="cd-card">
              <div className="cd-curriculum-head">
                <h2>Student reviews</h2>
                {avgRating != null && (
                  <p>
                    {avgRating.toFixed(1)} · {reviews.length} review
                    {reviews.length === 1 ? "" : "s"}
                  </p>
                )}
              </div>

              {reviews.length === 0 ? (
                <p className="cd-empty">No reviews yet.</p>
              ) : (
                <div className="cd-reviews">
                  {reviews.map((review, i) => {
                    const { trainee, review: comment, rating } = review;
                    const fullName = `${trainee.first_name} ${trainee.last_name}`;
                    const profileImage = trainee.image_path
                      ? `${
                          AxiosInstance.defaults.baseURL
                        }/media/${trainee.image_path.replace(/\\/g, "/")}`
                      : trainee.gender === "Male"
                      ? MaleLogo
                      : FemaleLogo;

                    return (
                      <article key={i} className="cd-review">
                        <img src={profileImage} alt="" />
                        <div>
                          <h3>{fullName}</h3>
                          <div className="cd-stars">{renderStars(rating)}</div>
                          <p>{comment}</p>
                        </div>
                      </article>
                    );
                  })}
                </div>
              )}
            </section>
          </main>

          <aside className="cd-sidebar">
            <div className="cd-enroll-card">
              <h3>Batch details</h3>
              <ul className="cd-enroll-facts">
                {courseData.batch_starts_at && (
                  <li>
                    <FiCalendar /> Starts {courseData.batch_starts_at}
                  </li>
                )}
                {courseData.timings && (
                  <li>
                    <FiClock />
                    {courseData.timings}
                    {courseData.timezone ? ` (${courseData.timezone})` : ""}
                  </li>
                )}
                {courseData.duration && (
                  <li>
                    <FiUsers /> Duration {courseData.duration}
                  </li>
                )}
                {courseData.mode && (
                  <li>
                    <FiMonitor /> {courseData.mode}
                  </li>
                )}
              </ul>
              {enrollButton}
              <SaveButton itemType={SAVED_TYPES.TRAINING} itemId={batchId} />
            </div>

            {instructor && (
              <div className="cd-trainer-card">
                <h3>About the trainer</h3>
                <div className="cd-trainer-row">
                  <img src={getImageSrc(instructor)} alt="" />
                  <div>
                    <strong>{getDisplayName(instructor)}</strong>
                    <span>
                      {user ? "Institute" : "Independent trainer"}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </aside>
        </div>
      </div>

      {showModal && (
        <div className="Overlay" onClick={() => setShowModal(false)}>
          <div
            className="enroll-modal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="cd-enroll-modal-title"
          >
            <button
              type="button"
              className="enroll-modal-close"
              onClick={() => setShowModal(false)}
              aria-label="Close"
            >
              <FaTimes />
            </button>
            <h2 id="cd-enroll-modal-title">
              {isSignupMode ? "Sign up to enroll" : "Log in to enroll"}
            </h2>
            <p className="enroll-modal-sub">
              {isSignupMode
                ? "Create an account to continue your enrollment."
                : "Welcome back. Sign in to continue enrollment."}
            </p>
            <form onSubmit={isSignupMode ? handleSignup : handleSubmit}>
              {isSignupMode && (
                <>
                  <div className="enroll-field-row">
                    <div className="enroll-field">
                      <label htmlFor="first_name">First name</label>
                      <input
                        type="text"
                        id="first_name"
                        name="first_name"
                        value={formData.first_name || ""}
                        onChange={handleChange}
                        placeholder="First name"
                        required
                      />
                    </div>
                    <div className="enroll-field">
                      <label htmlFor="last_name">Last name</label>
                      <input
                        type="text"
                        id="last_name"
                        name="last_name"
                        value={formData.last_name || ""}
                        onChange={handleChange}
                        placeholder="Last name"
                        required
                      />
                    </div>
                  </div>
                  <div className="enroll-field">
                    <label htmlFor="mobile_no">Mobile number</label>
                    <input
                      type="tel"
                      id="mobile_no"
                      name="mobile_no"
                      value={formData.mobile_no || ""}
                      onChange={handleChange}
                      placeholder="Mobile number"
                      required
                    />
                  </div>
                </>
              )}
              <div className="enroll-field">
                <label htmlFor="email">
                  {isSignupMode ? "Email" : "Email or mobile number"}
                </label>
                <input
                  type={isSignupMode ? "email" : "text"}
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder={
                    isSignupMode ? "Email" : "Email or mobile number"
                  }
                  autoComplete="username"
                  required
                />
              </div>
              <div className="enroll-field">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Password"
                  required
                />
              </div>
              <button type="submit" className="enroll-modal-submit">
                {isSignupMode ? "Sign up & enroll" : "Log in & enroll"}
              </button>
            </form>
            <p className="enroll-modal-switch">
              {isSignupMode ? (
                <>
                  Already have an account?{" "}
                  <button type="button" onClick={() => setIsSignupMode(false)}>
                    Log in
                  </button>
                </>
              ) : (
                <>
                  Don&apos;t have an account?{" "}
                  <button type="button" onClick={() => setIsSignupMode(true)}>
                    Sign up
                  </button>
                </>
              )}
            </p>
          </div>
        </div>
      )}

      <Footers />
    </div>
  );
}
